import { readonly, ref } from "vue";
import { api } from "@/api";
import { NotificationType } from "../../types";
import { updateUser } from "../user/store";

const isSmsEnabled = ref<boolean>();
const isEmailEnabled = ref<boolean>();
const isNewsletterEnabled = ref<boolean>();

const updateEmailNotification = async (
  value: boolean,
  additionalProps?: Record<string, any>
): Promise<void> => {
  await api.profile.setNotification(
    NotificationType.ReservationReminderEmail,
    value,
    additionalProps
  );
  isEmailEnabled.value = value;
};

const updateSMSNotification = async (
  value: boolean,
  phone?: string,
  additionalProps?: Record<string, any>
): Promise<void> => {
  await api.profile.setNotification(
    NotificationType.ReservationReminderSms,
    value,
    { phone, ...additionalProps }
  );
  isSmsEnabled.value = value;
  if (phone != null) {
    updateUser({ phone });
  }
};

const updateNewsletterNotification = async (
  value: boolean,
  additionalProps?: Record<string, any>
): Promise<void> => {
  await api.profile.setNotification(
    NotificationType.Newsletter,
    value,
    additionalProps
  );
  isNewsletterEnabled.value = value;
};

const updatePhoneNumber = async (value: string): Promise<void> => {
  await api.profile.updatePhone({ phone: value });
  updateUser({ phone: value });
};

const isEmailEnabledReadonly = readonly(isEmailEnabled);
const isSmsEnabledReadonly = readonly(isSmsEnabled);
const isNewsletterEnabledReadonly = readonly(isNewsletterEnabled);

export {
  isEmailEnabledReadonly as isEmailEnabled,
  isSmsEnabledReadonly as isSmsEnabled,
  isNewsletterEnabledReadonly as isNewsletterEnabled,
  updateEmailNotification,
  updateSMSNotification,
  updateNewsletterNotification,
  updatePhoneNumber,
};
